import { getLocationIdForMetro } from '../../../../../shared/utils/geo';
import { UndergroundTimeNewContainer } from '../../containers/advancedFilters/UndergroundTimeNewContainer';
import { IFilter } from '../../types/advancedFilters';
import { REGIONS_WITH_UNDERGROUND } from '../regions';

export const undergroundTimeNew: IFilter = {
  availability: ({ currentLocation }) => {
    const locationId = getLocationIdForMetro(currentLocation);

    return REGIONS_WITH_UNDERGROUND.includes(locationId);
  },
  component: UndergroundTimeNewContainer,
};
